import { AsModuleHelper, AsStoreModule } from '@/types/vuex/helpers';
import { createNamespacedHelpers, ActionContext, MutationTree, Dictionary } from 'vuex';
import { Theme } from '@/types/theme';
import { IRootState } from '@/store/rootstate';
import {
  IBankItem,
  IBankStrategy,
  OpenBankingStrategy,
  OpenBankingProcessState,
  IBankProvider,
  IProcessBankStrategyYodlee,
  IProgressResponse,
  IPdfFileTransfer,
  IReverseLookupResponses
} from '@/api/signup/interface';

export enum BankStrategy {
  OpenBanking = 'OpenBanking',
}

interface IState {
  completeUrl?: string;
  cancelUrl?: string;

  bank?: IBankItem;
  strategy?: IBankStrategy;

  bankProvider?: IBankProvider;

  signup: {
    fetching: boolean;
    requestId: string;
    intervalId: number;
    canceled: boolean;
    sentValidCreds: boolean;
    progress: IProgressResponse;
  };
  }

interface IGetters {
  dataProviderId?: number;
  bankProvider?: IBankProvider;
  allowedProviders: [];

  bank?: IBankItem;

  requestId?: string;

  strategy?: IBankStrategy;
  strategyType?: BankStrategy;
  bankStrategy: {
    OpenBanking: OpenBankingStrategy;
  };
  
  completeUrl?: string;
  cancelUrl?: string;

  signup: {
    fetching: boolean;
    requestId: string;
    intervalId: number;
    canceled: boolean;
    progress: IProgressResponse;
  };
}

/* Actions */
interface IActions {
  init(): Promise<any>;

  setBank(bank: IBankItem | null): Promise<any>;
  setDataProviderId(dataProviderId: number): Promise<any>;

  resolveDataProvider(bankId: string): Promise<IBankProvider>;
  getBankStrategy(): Promise<IBankStrategy>;
  getLookupInfo(): Promise<IReverseLookupResponses>;

  getCompleteUrl(): Promise<string>;

  getCancelUrl(): Promise<string>;
  
  getEarlyRedirectUrl(): Promise<string>;

  getProgress(): Promise<IProgressResponse>;
  
  getPdfFile(): Promise<IPdfFileTransfer>;

  completeSignup(): Promise<IBankStrategy | null>;

  cancelCurrentRequest(): Promise<any>;

  trackRequest(): Promise<any>;
  openWindow(url: string): Promise<any>;

  //#region  localstorage
  /**
   * Save state to be loaded
   * @param state state string
   */
  saveState(state: string): Promise<any>;
  /**
   * Loads from the state
   * @param state state string
   */
  loadFromState(state: string): Promise<any>;
  //#endregion

  validatePage(payload: { page: string; values: object }): Promise<boolean>;

  validateCurrentPage(payload: { page: string; values: object }): Promise<boolean>;

  processYodlee(request: IProcessBankStrategyYodlee): Promise<boolean>;

  clearBank(): Promise<void>; 
}
interface IStoreActions<S, R> {
  init(injectee: ActionContext<S, R>): Promise<any> | void;

  getCompleteUrl(injectee: ActionContext<S, R>): Promise<string>;
  getCancelUrl(injectee: ActionContext<S, R>): Promise<string>;
  getEarlyRedirectUrl(injectee: ActionContext<S, R>): Promise<string>;
  cancelCurrentRequest(injectee: ActionContext<S, R>): Promise<any>;

  setDataProviderId(injectee: ActionContext<S, R>, dataProviderId: number): Promise<any>;
  setBank(injectee: ActionContext<S, R>, bank: IBankItem | null): Promise<any> | void;

  resolveDataProvider(injectee: ActionContext<S, R>, bankId: string): Promise<any>;
  getBankStrategy(injectee: ActionContext<S, R>): Promise<IBankStrategy>;
  getLookupInfo(injectee: ActionContext<S, R>): Promise<IReverseLookupResponses>;
  getProgress(injectee: ActionContext<S, R>, requestId: string): Promise<IProgressResponse>;
 
  completeSignup(injectee: ActionContext<S, R>): Promise<IBankStrategy | null>;
  getPdfFile(injectee: ActionContext<S, R>): Promise<IPdfFileTransfer>;

  trackRequest(injectee: ActionContext<S, R>): Promise<any>;
  // openWindow(injectee: ActionContext<S, R>, url: string): Promise<any>;

  //#region  localstorage
  saveState(injectee: ActionContext<S, R>, state: string): Promise<any>;
  loadFromState(injectee: ActionContext<S, R>, state: string): Promise<any>;
  //#endregion

  validatePage(
    injectee: ActionContext<S, R>,
    payload: { page: string; values: object },
  ): Promise<boolean>;

  validateCurrentPage(
    injectee: ActionContext<S, R>,
    payload: { page: string; values: object },
  ): Promise<boolean>;

  processYodlee(
    injectee: ActionContext<S, R>,
    request: IProcessBankStrategyYodlee,
  ): Promise<boolean>;

  clearBank(injectee: ActionContext<S, R>): Promise<void>;
}
/* /Actions */

export enum Mutations {
  SET_BANK = 'SET_BANK',
  SET_STRATEGY = 'SET_STRATEGY',

  SET_FETCHING = 'SET_FETCHING',
  SET_REQUESTID = 'SET_REQUESTID',
  SET_INTERVALID = 'SET_INBTERVALID',
  SET_COMPLETE_URL = 'SET_COMPLETE_URL',
  SET_CANCEL_URL = 'SET_CANCEL_URL',

  SET_CANCELED = 'SET_CANCELED',
  SET_PROGRESS = 'SET_PROGRESS',

  SET_DATA_PROVIDER = 'SET_DATA_PROVIDER',
  RESET_SIGNUP = 'RESET_SIGNUP'
}

type MutationType<S, E, K = keyof keyof E> = { [k in keyof K]: MutationTree<S> };

export type module = AsStoreModule<
  IState,
  IGetters,
  IStoreActions<IState, IRootState>,
  MutationType<IState, Mutations>
>;
export default createNamespacedHelpers('signup') as AsModuleHelper<IState, IGetters, IActions>;
